import axios, { type AxiosError } from "axios";
import { apiPaths } from "./paths";

const api = axios.create({
  baseURL: `${process.env.API_URL || ""}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let onUnauthorized: (() => void) | null = null;

export function setOnUnauthorized(cb: () => void) {
  onUnauthorized = cb;
}

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    const reqUrl = err.config?.url ?? "";
    if (
      err.response?.status === 401 &&
      !reqUrl.includes("/auth/") &&
      !reqUrl.includes(apiPaths.users.me)
    ) {
      onUnauthorized?.();
    }
    return Promise.reject(err);
  },
);

export function extractErrorMessage(
  err: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as
      { message?: string | string[] } | undefined;
    if (data?.message) {
      return Array.isArray(data.message)
        ? data.message.join(", ")
        : data.message;
    }
    if (err.message) return err.message;
    return fallback;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}

export default api;
